<app-dialog
  customClass="card-payments-info-dialog"
  [dialogType]="dialogType"
  [stackActions]="true"
  [primaryActionText]="'DIALOG.PAYMENTS.LABEL.LEARN_MORE' | translate"
  (onPrimaryAction)="goToLearnMore()"
>
  <div class="card-payments-info-dialog">
    <app-icon
      class="underwriting-stripe-canvas-icon"
      [icon]="underwritingStripeCanvasIcon"
    >
    </app-icon>

    <div class="contents">
      <div class="title">
        {{ 'DIALOG.PAYMENTS.HEADER.CARD_PAYMENTS_WITH_STRIPE' | translate }}
      </div>

      <p class="description">
        {{ 'DIALOG.PAYMENTS.DESCRIPTION.STRIPE_ONBOARDING_1' | translate }}
      </p>

      <p class="description">
        {{ 'DIALOG.PAYMENTS.DESCRIPTION.STRIPE_ONBOARDING_3' | translate }}
      </p>

      <p class="description">
        {{ description }}
      </p>
    </div>
  </div>
</app-dialog>
